module.exports = __webpack_public_path__ + "images/organization/out-of-free-team-boards.f8b57dee17ba25a2f66a.svg";